import { Vector2 } from 'three';

export function drawArrow(
  ctx: CanvasRenderingContext2D,
  start: Vector2,
  end: Vector2,
  theta: number = 30,
  headlen: number = 10,
  width: number = 1,
  color: string | CanvasGradient | CanvasPattern = 'red',
) {
  const angle = (Math.atan2(start.y - end.y, start.x - end.x) * 180) / Math.PI,
    angle1 = ((angle + theta) * Math.PI) / 180,
    angle2 = ((angle - theta) * Math.PI) / 180,
    topX = headlen * Math.cos(angle1),
    topY = headlen * Math.sin(angle1),
    botX = headlen * Math.cos(angle2),
    botY = headlen * Math.sin(angle2);
  ctx.save();
  ctx.beginPath();
  let arrowX: number, arrowY: number;
  ctx.moveTo(start.x, start.y);
  ctx.lineTo(end.x, end.y);
  arrowX = end.x + topX;
  arrowY = end.y + topY;
  ctx.moveTo(arrowX, arrowY);
  ctx.lineTo(end.x, end.y);
  arrowX = end.x + botX;
  arrowY = end.y + botY;
  ctx.lineTo(arrowX, arrowY);
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.stroke();
  ctx.restore();
}
